(function() {
	if(window.innerWidth < 960) {
		return;
	}
	if(location.pathname.startsWith("/contact")) {
		return;
	}

	let parallaxElementList = document.querySelectorAll("main>header");
	if(parallaxElementList.length === 0) {
		return;
	}

	let debounceTime = 50;
	let debounceTimeout = null;
	debounceScroll(parallax);

	window.addEventListener("scroll", () => debounceScroll(parallax));

	function debounceScroll(callback) {
		if(debounceTimeout) {
			return;
		}
		parallax();
		debounceTimeout = setTimeout(() => {
			debounceTimeout = null;
			parallax();
		}, debounceTime);
	}

	function parallax() {
		parallaxElementList.forEach(header => {
			header.style.backgroundPositionY = -(window.scrollY / 4) + "px";
		});
	}
})();
